module.exports = __webpack_public_path__ + "img/años.49c8af60.svg";